import createIcon from '../../createIcon';

/**
 * @component @name SpatialTracking
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41NTk1NyAxNEMxMS43Njg3IDE0IDEzLjU1OTYgMTIuMjA5MSAxMy41NTk2IDEwQzEzLjU1OTYgNy43OTA4NiAxMS43Njg3IDYgOS41NTk1NyA2QzcuMzUwNDMgNiA1LjU1OTU3IDcuNzkwODYgNS41NTk1NyAxMEM1LjU1OTU3IDEyLjIwOTEgNy4zNTA0MyAxNCA5LjU1OTU3IDE0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1Ljk0OTYgMTYuNTZDMTQuMjY5NiAxNS43IDEyLjA4OTYgMTUgOS41NTk1NyAxNUM3LjAyOTU3IDE1IDQuODQ5NTcgMTUuNyAzLjE2OTU3IDE2LjU2QzIuMTY5NTcgMTcuMDcgMS41NTk1NyAxOC4xIDEuNTU5NTcgMTkuMjJWMjJIMTcuNTU5NlYxOS4yMkMxNy41NTk2IDE4LjEgMTYuOTQ5NiAxNy4wNyAxNS45NDk2IDE2LjU2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5LjYwOTYgMy40MUwxOC4xOTk2IDJDMTQuNjg5NiA1LjUxIDE0LjY4OTYgMTEuMjEgMTguMTk5NiAxNC43M0wxOS42MDk2IDEzLjMyQzE2Ljg3OTYgMTAuNTggMTYuODc5NiA2LjE0IDE5LjYwOTYgMy40MVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMi40Mzk2IDYuMjRMMjEuMDI5NiA0LjgzQzE5LjA3OTYgNi43OCAxOS4wNzk2IDkuOTUgMjEuMDI5NiAxMS45TDIyLjQzOTYgMTAuNDlDMjEuMjY5NiA5LjMyIDIxLjI2OTYgNy40MSAyMi40Mzk2IDYuMjRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SpatialTracking = createIcon('SpatialTracking', [
  [
    'path',
    {
      d: 'M9.55957 14C11.7687 14 13.5596 12.2091 13.5596 10C13.5596 7.79086 11.7687 6 9.55957 6C7.35043 6 5.55957 7.79086 5.55957 10C5.55957 12.2091 7.35043 14 9.55957 14Z',
      key: '1ykyf7',
    },
  ],
  [
    'path',
    {
      d: 'M15.9496 16.56C14.2696 15.7 12.0896 15 9.55957 15C7.02957 15 4.84957 15.7 3.16957 16.56C2.16957 17.07 1.55957 18.1 1.55957 19.22V22H17.5596V19.22C17.5596 18.1 16.9496 17.07 15.9496 16.56Z',
      key: 'n8qs2c',
    },
  ],
  [
    'path',
    {
      d: 'M19.6096 3.41L18.1996 2C14.6896 5.51 14.6896 11.21 18.1996 14.73L19.6096 13.32C16.8796 10.58 16.8796 6.14 19.6096 3.41Z',
      key: '1n5y3p',
    },
  ],
  [
    'path',
    {
      d: 'M22.4396 6.24L21.0296 4.83C19.0796 6.78 19.0796 9.95 21.0296 11.9L22.4396 10.49C21.2696 9.32 21.2696 7.41 22.4396 6.24Z',
      key: '1bff1z',
    },
  ],
]);

export default SpatialTracking;
